<template>
  <footer>
    <div class="footer-main width_fixed">
      <div class="footer-left">
        <dl>
          <dt>快捷入口</dt>
          <dd><router-link to="/">首页</router-link></dd>
          <dd><router-link to="/about">关于霖梓</router-link></dd>
          <dd><router-link to="/business">业务纵横</router-link></dd>
          <dd><router-link to="/contact">联系我们</router-link></dd>
        </dl>
        <dl>
          <dt>关于霖梓</dt>
          <dd><router-link to="/about?type=introduce">公司介绍</router-link></dd>
          <dd><router-link to="/about?type=develop">发展历程</router-link></dd>
        </dl>
        <dl>
          <dt>业务纵横</dt>
          <dd><router-link to="/business?type=a">易借速贷</router-link></dd>
          <dd><router-link to="/business?type=b">PITPAT</router-link></dd>
          <dd><router-link to="/business?type=c">瑞博国际</router-link></dd>
          <dd><router-link to="/business?type=d">物流管理</router-link></dd>
        </dl>
        <dl>
          <dt>联系我们</dt>
          <dd><router-link to="/contact?type=a">公司地址</router-link></dd>
          <dd><router-link to="/contact?type=b">媒体联系</router-link></dd>
        </dl>
        <dl>
          <dt>友情链接</dt>
          <dd><a href="https://www.blingfintech.com/" target="_blank">易借速贷</a></dd>
        </dl>
      </div>
      <div class="footer-right">
        <p>霖梓微信订阅号</p>
        <img src="@/assets/img/pc/qrCode.jpg" alt>
      </div>
    </div>
    <div class="bt">
      <div class="bt-main">
        <img src="@/assets/img/pc/footer-logo.png" alt="">
        <span>Copyright ©2018 浙江霖梓控股有限公司 <a href="https://beian.miit.gov.cn/#/Integrated/index" target="_blank">浙ICP备18013090号</a></span>
      </div>
    </div>
  </footer>
</template>

<script>
  export default {};
</script>

<style lang="less">
  footer {
    background:#333;
    .footer-main {
      padding: 40px 0 165px;
      display: flex;
      justify-content: space-between;
      .footer-left {
        display: flex;
        justify-content: space-between;
        margin-left: 60px;
        dl {
          padding-right: 64px;
          dt {
            font-size: 14px;
            color: #fff;
            line-height: 20px;
            font-family: PingFangSC, PingFangSC-Regular;
          }
          dd {
            margin-top: 12px;
            a {
              font-size: 12px;
              color: #bcbcbc;
              line-height: 16px;
              font-family: PingFangSC, PingFangSC-Regular;
            }
          }
        }
      }
      .footer-right {
        margin-right: 60px;
        p {
          font-size: 14px;
          font-family: PingFangSC, PingFangSC-Regular;
          color:#ffffff; 
          line-height: 20px;
        }
        img {
          width: 100px;
          height: 100px;
          margin-top: 10px;
        }
      }
    }
    .bt {
      background: #2d2d2d;
      text-align: center;
      padding: 24px 0;
      .bt-main {
        display: flex;
        align-items: center;
        justify-content: center;
      }
      img {
        width: 123px;
        margin-right: 10px;
      }
      span {
        font-family: PingFangSC-Regular, sans-serif;
        font-weight: 300;
        letter-spacing: 1px;
        font: 14px "microsoft yahei", Tahoma, Arial, "宋体",Helvetica, Sans-serif;
        color: #666;
      }
      a {
        color: #666;
      }
    }
  }
</style>
